import { useAppState } from './use-mobile-service'
import { AbilityAction } from '../../enums/ability-action.enum'
import { SubjectEntity } from '../../enums/ability-entity.enum'

interface NotificationPermissions {
    canCreate: boolean
    canUpdate: boolean
    /** True once abilities have been loaded. Use to avoid rendering permission-dependent UI prematurely. */
    ready: boolean
}

/**
 * Returns CASL-based notification permissions for the current domain.
 * Reads from the ability store reactively (works with MobX observer).
 *
 * The `ready` flag indicates whether abilities have been loaded.
 * When `ready` is false, canCreate/canUpdate default to false — consumers
 * should avoid rendering permission-gated UI until ready is true.
 */
export function useNotificationPermissions(): NotificationPermissions {
    const appState = useAppState()
    const abilities = appState.abilityStore.abilities
    const ready = abilities.rules.length > 0

    if (!ready) {
        return { canCreate: false, canUpdate: false, ready: false }
    }

    const notifIdentity = appState.abilityStore.getDomainOwnedIdentityFor(SubjectEntity.NOTIFICATION)

    return {
        canCreate: appState.abilityStore.can(AbilityAction.CREATE, notifIdentity),
        canUpdate: appState.abilityStore.can(AbilityAction.UPDATE, notifIdentity),
        ready: true,
    }
}
